<template>
    <div class="new_ERPShopAdmin">
         
        <div class="u-max-width  ERPShopAdminbanner">
               <div class="ERPShop-bannnertext">
                  <div class="ERPShop-bannnertext1">全球物联网连接运营平台</div>
                  <div class="ERPShop-bannnertext2">移动、电信、联通以及全球运营商SIM卡连接运营管理行业运营管理平台</div>
               </div>
        </div>
         <div class="u-max-width u-p-t-140 u-p-b-90 supplierAdminItem6bg">
            <div class="u-min-width supplierAdminItem6">
                <div class="supplierAdminItem6View u-flex u-row-between">
                    <div class="supplierAdminItem6-item">
                        <img src="../../../assets/myimage/pingtai3.webp" alt="">
                         <div class="supplierAdminItem6-item-title2">
                            <h1>6800+</h1>
                            <p>月活跃企业客户</p>
                         </div>
                    </div>
                     <div class="supplierAdminItem6-item">
                        <img src="../../../assets/myimage/pingtai3.webp" alt="">
                         <div class="supplierAdminItem6-item-title2">
                            <h1>1亿+</h1>
                            <p>API日均访问量</p>
                         </div>
                    </div>
                     <div class="supplierAdminItem6-item">
                        <img src="../../../assets/myimage/pingtai3.webp" alt="">
                         <div class="supplierAdminItem6-item-title2">
                            <h1>4680万+</h1>
                            <p>累计连接终端数</p>
                         </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="u-max-width u-p-t-160 u-p-b-40 supplierAdminItem5bg">
             <div class="u-min-width u-p-t-40 u-p-b-20 u-p-b-40 supplierAdminItem5">
                   <div class="supplierAdminItem5Title">物联网卡CMP连接管理平台</div>
                   <div class="u-flex u-row-between" style="margin:0 auto;max-width:1054px;">
                        <div>
                            <div class="supplierAdminItems1">
                                <h1 class="u-m-b-15">卡片管理</h1>
                                <p>卡片管理包括三大运营商卡片库存、划拨、套餐订购、套餐转移、</p>
                                <p>生命周期管控、数据监控管理、自动诊断等，三网卡片一平台管控</p>
                            </div>
                            <div class="u-flex u-row-between">
                                <div class="supplierAdminItems3">
                                    <h1 class="u-m-b-15">套餐管理</h1>
                                <p>套餐管理包括自运营流量套餐和</p>
                                <p>语音套餐、组合套餐管理、</p>
                                <p>自主定价套餐</p>
                                </div>
                                <div class="supplierAdminItems4">
                                    <h1 class="u-m-b-15">月包共享</h1>
                                    <p>流量池管理、共享池管理等功能，</p>
                                    <p>支持池中池模式，方便集团企业，</p>
                                    <p>集团统管，分区管理和调度流量资源</p>
                                </div>
                            </div>
                        </div>   
                        <div class="supplierAdminItems2">
                            <h1 class="u-m-b-15">公众号充值模板</h1>
                            <p>平台支持多级客户账户体系</p>
                            <p>代理商能拥有自己的公众号和充值页面</p>
                        </div>   
                   </div>
                   <div class="u-flex u-row-between u-m-t-15" style="margin:0 auto;max-width:1054px;">
                        <div class="supplierAdminItems5">
                            <h1 class="u-m-b-15">客户和分润管理</h1>
                            <p>级客户账号管理、分润管理、订单管理</p>
                            <p>分润金额实时査看</p>
                        </div>
                        <div class="supplierAdminItems6">
                            <h1 class="u-m-b-15">营销活动和运营管理</h1>
                                    <p>支持优惠券、红包、首充优惠</p>
                                    <p>提高用户激活率、 复充率运营管理，辅助客户</p>
                                    <p>日常经营卡片的一切运营工作</p>
                        </div>
                   </div>
             </div>
        </div>
        <div class="u-max-width u-p-t-60 u-p-b-40 ERPShopAdminItem5bg">
             <div class="u-min-width u-p-t-40 u-p-b-20 u-p-b-40 ERPShopAdminItem5">
                    <div class="ERPShopAdminItem5-item ">
                        <div class="ERPShopAdminItem5-top u-flex u-col-center u-p-t-30 u-p-b-60" style="flex-direction: column;">
                            <div class="ERPShopAdminItem5-top-View">
                                <!-- <img class="imgLeft" src="../../../assets/images/newImg/tubiao.png"> -->
                                 <span>场景介绍</span> 
                                 <!-- <img class="imgright"  src="../../../assets/images/newImg/tubiao.png"> -->
                             </div>
                        </div>
                        <ul class="u-flex u-row-between ERPShopAdminItem5-ul">
                            <li>
                                <div>
                                     <div class="ul-title1">标准套餐场景</div>
                                     <div class="ul-title2">★独特的月包共享管理版块，支持池中池模式，方便集团企业，集团统管，分区管理和调度流量资源</div>
                                     <!-- <div class="ul-title2">★统计分析，可查看：单卡用量报表、SIM卡套餐用量、月累计量趋势报表、日累计量趋势报表、物联卡</div> -->
                                     <!-- <div class="ul-title2">&nbsp;&nbsp;&nbsp;用量年报表、SIM卡数量统计、月账单统计、地理位置统计</div> -->
                                     <div class="ul-title2">★支持批量充值、批量备注卡片和分组管理</div>
                                     <div class="ul-title2">★单卡阀值管控，流量池阀值管控</div>
                                     <div class="ul-title2">★卡片套餐到期邮件提醒</div>
                                </div>
                            </li>
                            <li>
                                <div>
                                        <div class="ul-title1">语音卡场景</div>
                                        <div class="ul-title2">★支持单卡余额钱包计费模式、套餐计费模式、实名激活自动订购套餐模式</div>
                                        <div class="ul-title2">★多级客户分润体系</div>
                                        <div class="ul-title2">★营销活动系统，引导用户激活体验，提高复充率</div>
                                        <div class="ul-title2">★平台公众号到期提醒功能</div>
                                        <!-- <div class="ul-title2">★提前停机节省成本，单卡状态独家显示：睡眠状态，提前停机也无用户投诉</div> -->
                                </div>
                                
                            </li>
                          
                        </ul>
                        <ul class="u-flex u-row-between ERPShopAdminItem5-ul u-m-t-20">
                            <li>
                                <div>
                                    <div class="ul-title1">2B2C场景</div>
                                    <div class="ul-title2">★支持单卡余额钱包计费模式、套餐计费模式</div>
                                    <div class="ul-title2">★多级客户分润体系，可微信支付宝分润提现，秒返功能</div>
                                    <!-- <div class="ul-title2">★公众号支持多卡管理，方便小型工作室管理</div> -->
                                    <div class="ul-title2">★平台公众号到期提醒功能</div>
                               </div>
                            </li>
                            <li>
                                <div>
                                    <div class="ul-title1">安防行业场景</div>
                                    <div class="ul-title2">★支持单卡余额钱包计费模式、套餐计费模式</div>
                                    <!-- <div class="ul-title2">★支持支付宝、微信授权自动续费模式</div> -->
                                    <div class="ul-title2">★多级客户分润体系</div>
                                    <div class="ul-title2">★公众号支持多卡管理，方便鱼塘、工厂、农业客户管理</div>
                                    <div class="ul-title2">★支持H5页面嵌入APP</div>
                                    <div class="ul-title2">★平台公众号到期提醒功能</div>
                               </div>
                            </li>
                        </ul>
                        <ul class="u-flex u-row-between ERPShopAdminItem5-ul u-m-t-20">
                            
                            <li>
                                <div>
                                    <div class="ul-title1">上网终端场景</div>
                                    <div class="ul-title2">★支持单卡余额钱包计费模式、套餐计费模式</div>
                                    <!-- <div class="ul-title2">★支持支付宝、微信授权自动续费模式</div> -->
                                    <div class="ul-title2">★营销活动系统，引导用户激活体验，提高复充率</div>
                                    <div class="ul-title2">★多级客户分润体系</div>
                                    <div class="ul-title2">★平台公众号到期提醒功能</div>
                               </div>
                            </li>
                            <li>
                                <div>
                                    <div class="ul-title1">结算场景</div>
                                    <div class="ul-title2">★支持低消流量池、电信单卡阶梯、按GB结算</div>
                                    <div class="ul-title2">★支持套餐结算、实时扣费模式</div>
                                    <div class="ul-title2">★③兼容多运营商按G结算功能</div>
                                    <div class="ul-title2">★④结算模式多样，包含单卡按G结算、套餐按G结算、账户按G结算</div>
                               </div>
                            </li>
                        </ul>
                   </div>
                  
             </div>
        </div>
        <div class="u-max-width u-p-t-40 u-p-b-90" style ="background:#F0F0F0">
              <div class="u-min-width ERPShopAdminItem8">
                <div class="ERPShopAdminItem8Title u-p-t-100 u-m-b-90">平台系统功能架构</div>
                <div style="width:1164px;height:700px;margin:0 auto">
                <el-carousel indicator-position="outside" trigger="click" arrow="never" height="700px" :autoplay="false">
                    <!-- <el-carousel-item :label="'IOT全球连接运营服务全景图'" style="height:600px">
                      <img src="../../../assets/myimage/pingtaibanner1.webp" alt="">
                    </el-carousel-item> -->
                    <el-carousel-item :label="'CMP连接平台中台核心架构'"  style="height:700px">
                      <img src="../../../assets/myimage/banner2.jpg" style="width:1164px;heigth:700px" alt="">
                    </el-carousel-item>
                    <el-carousel-item :label="'物联网通信系统架构'" style="height:700px">
                      <img src="../../../assets/myimage/banner1.jpg" style="width:1164px;heigth:700px" alt="">
                    </el-carousel-item>
                </el-carousel>
            </div>
              </div>
        </div>
        <myNewFoot :show="false"></myNewFoot>
    </div>
</template>
<script>
import myNewMenu from "@/components/newcomponents/myNewMenu"
import myNewFoot from "@/components/newcomponents/myNewFoot"
export default {
    name:'new_ERPShopAdmin',
    data(){
        return {

        }
    },
    components:{
        myNewMenu,
        myNewFoot
    },
    methods:{
         download() {
                var downloadUrl = 'https://file.onebose.com/ONEBO_ERP.msi'
                var aLink = document.createElement('a')
                aLink.style.display = 'none'
                aLink.href = downloadUrl
                aLink.setAttribute('download', '')
                document.body.appendChild(aLink)
                aLink.click()
                document.body.removeChild(aLink)
            
        } ,
          handleClick(url){
            this.$router.push({
                path:url
            })
          }
    }
    
}
</script>
<style lang="scss">
.new_ERPShopAdmin{
    .el-carousel__indicators--labels .el-carousel__indicator{
        font-size: 22px !important;
        padding: 20px !important;
        >button{
            font-size: 22px !important;
            padding: 10px 15px;
            background: #ccc;
            border-radius: 10px;
            color: #000 !important;
        }
    }
}
</style>
<style lang="scss" scoped>

 .new_ERPShopAdmin{
    font-family: PingFang SC-Regular, PingFang SC;

     .ERPShopAdminbanner{
         background: url("../../../assets/myimage/pingtai.webp");
         background-size: 100% 100%;
         height: 500px;
         position: relative;
         .ERPShop-bannnertext{
            width: 880px;
            position: absolute;
            top:150px;
            left: 250px;
            .ERPShop-bannnertext1{
                font-size: 3rem;
                font-family: PingFang SC-Medium, PingFang SC;
                font-weight: 500;
                color: #127bf2;
            }
            .ERPShop-bannnertext2{
               margin-top: 30px;
               font-size: 24px;
               font-family: PingFang SC-Regular, PingFang SC;
               font-weight: 400;
                color: #000;
            }
            .ERPShop-bannnertext3{
               font-size: 18px;
               font-family: PingFang SC-Regular, PingFang SC;
               font-weight: 400;
                color: #ffffffab;
                .rudios{
                    display: inline-block;
                    width: 10px;
                    height: 10px;
                    border-radius: 5px;
                    background: #FC6B1D;
                    margin-right: 10px;
                }
            }
            .ERPShop-bannnerbtn{
                display: flex;
                margin-top: 20px;
                & div{
                    width: 100px;
                    height: 40px;
                    line-height: 40px;
                    text-align: center;
                    font-size: 13px;
                    font-family: PingFang SC-Regular, PingFang SC;
                    font-weight: 400;
                    cursor: pointer;
                }
                .bannnerbtn{
                    background: linear-gradient(90deg, #FC6B1D 0%, #F98F43 100%);
                    color: #fff;
                }
                .bannnerbtn2{
                    margin-left: 20px;
                    
                    color: #FD681C

                }
            }
         }
         .ERPShop-bannnerlogo{
            position: absolute;
            top: 50px;
            right: 400px;
            z-index: 10;
         }
         .ERPShop-foot{
             position: absolute;
             bottom: 0;
             left: 0;
             width: 100%;
             height: 150px;
             background: #fcfcfc38;
             font-size: 14px;
             font-family: PingFang SC-Regular, PingFang SC;
             font-weight: 400;
             color: #FFF;
         }
    }

   .ERPShopAdminItem5bg{
        background: #fff;
        .ERPShopAdminItem5{
        .ERPShopAdminItem5-top{
            // background: url("../../../assets/images/newImg/ERPShopImg.png");
            background-size: 100% 100%;
            .ERPShopAdminItem5-top-View{
                position: relative;
                font-size: 36px;
                font-family: PingFang SC-Medium, PingFang SC;
                font-weight: 400;
                color: #4E5968;
                .imgLeft{
                    transform: rotateY(180deg);
                    // position: absolute;
                    // left: 0;
                }
                & span{
                    margin-left: -36px;
                    position: relative;
                    bottom: 13px;
                    z-index: 10;
                }
                .imgright{
                    margin-left: -36px;
                }
            }
            .ERPShopAdminItem5-top-View2{
                font-size: 16px;
                font-family: PingFang SC-Medium, PingFang SC;
                font-weight: 500;
                color: #7A838F;
            }
        } 
        .ERPShopAdminItem5-ul1{
            display: flex;
            justify-content: space-between;
            align-items: center;

            & li{
                flex: 1;
                padding: 0 50px;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
                .ul-title1{
                    font-size: 16px;
                    font-family: PingFang SC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #000;
                    margin: 10px 0 10px 0;
                }
                .ul-title2{
                    font-size: 14px;
                    font-family: PingFang SC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #9898A4;
                    padding-right: 30px;
                }
                .ul-title-btn{
                    margin-top: 6px;
                    font-size: 14px;
                    font-family: PingFang SC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #FD681C;
                    text-align: center;
                    cursor: pointer;
                }
            }
        }
        .ERPShopAdminItem5-ul{
            background: #FFF;
            & li{
                width: 640px;
                height: 130px;
                padding:15px 10px 35px 25px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                background: linear-gradient(269deg, #F6F6F6 0%, #ECECEC 100%);
                box-shadow: 0px 3px 21px 1px rgba(56,89,197,0.03);
                border-radius: 8px 8px 8px 8px;
                opacity: 1;
                border: 2px solid #FFFFFF;
                .ul-img{
                    & img{
                        width: 120px;
                    }
                    // width: 40px;
                    // height: 38px;
                    // background: url("../../../assets/images/newImg/ERPShopImg4.png");
                }
                .ul-title1{
                    font-size: 16px;
                    font-family: PingFang SC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #000;
                }
                .ul-title2{
                    font-size: 14px;
                    font-family: PingFang SC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #9898A4;
                }
                .ul-title-btn{
                    margin-top: 6px;
                    font-size: 14px;
                    font-family: PingFang SC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #FD681C;
                    width: 100px;
                    height: 34px;
                    border-radius: 2px 2px 2px 2px;
                    border: 1px solid #FD681C;
                    line-height: 34px;
                    text-align: center;
                    cursor: pointer;
                }
            }
           
            
           
        }
       
        }
    }
     .ERPShopAdminItem6bg{
        background:#FFF;
        .ERPShopAdminItem6{
             .ERPShopAdminItem6Title{
                font-size: 20px;
                font-family: PingFang SC-Semibold, PingFang SC;
                font-weight: 600;
                color: #000000;
                text-align: center;
             }
             .ERPShopAdminItem6-item{
                li{
                    width: 297px;
                    height: 278px;
                    padding: 30px 20px 0 20px;
                    background: linear-gradient(312deg, #FAFEFF 0%, #F2F3F7 100%);
                    box-shadow: 0px 3px 21px 1px rgba(56,89,197,0.03);
                    border-radius: 8px 8px 8px 8px;
                    opacity: 1;
                    border: 2px solid #FFFFFF;
                    .ERPShopAdminItem6-text{
                        font-size: 18px;
                        font-family: PingFang SC-Medium, PingFang SC;
                        font-weight: 500;
                        color: #000000;
                    }
                    .ERPShopAdminItem6-text2{
                        font-size: 15px;
                        font-family: PingFang SC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #999999;
                        padding-right:60px;
                        margin-top: 20px;
                    }
                    .ERPShopAdminItem6-btn{
                        display: flex;
                        justify-content: space-between;
                        & div{
                            width: 100px;
                            height: 30px;
                            line-height: 30px;
                            text-align: center;
                            margin-top: 50px;
                            border-radius: 2px 2px 2px 2px;
                            opacity: 1;
                            border: 1px solid #FD681C;
                            font-size: 14px;
                            font-family: PingFang SC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #FD681C;
                            cursor: pointer;
                        }
                        & img{
                            width: 170px;
                        }
                    }
                }
                
             }
        }
    }
    .supplierAdminItem5bg{
        background: #FFF;
        .supplierAdminItem5{
        .supplierAdminItem5Title{
           font-size: 36px;
           text-align: center;
           font-family: PingFang SC-Semibold, PingFang SC;
           font-weight: 400;
           color: #000000;
           
        }
        .supplierAdminItems1{
            background: url('../../../assets/myimage/pingtai6.webp');
            width: 700px;
            height: 186px;
            margin-bottom: 14px;
            box-sizing: border-box;
            padding: 30px 0 0 40px;
           }
           .supplierAdminItems2{
            background: url('../../../assets/myimage/pingtai7.webp');
            width: 341px;
            height: 384px;
            box-sizing: border-box;
            padding: 30px 0 0 40px;
           }
           .supplierAdminItems3{
            background: url('../../../assets/myimage/pingtai8.webp');
            width: 341px;
            height: 186px;
            box-sizing: border-box;
            padding: 30px 0 0 40px;
           }
           .supplierAdminItems4{
            background: url('../../../assets/myimage/pingtai9.webp');
            width: 341px;
            height: 186px;
            box-sizing: border-box;
            padding: 30px 0 0 40px;
           }
           .supplierAdminItems5{
            background: url('../../../assets/myimage/pingtai10.webp');
            width: 520px;
            height: 186px;
            box-sizing: border-box;
            padding: 30px 0 0 40px;
           }
           .supplierAdminItems6{
            background: url('../../../assets/myimage/pingtai11.webp');
            width: 520px;
            height: 186px;
            box-sizing: border-box;
            padding: 30px 0 0 40px;
           }
        .supplierAdminItem5Title2{
            font-size: 16px;
             text-align: center;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
        }
        
        .supplierAdminItem5-ul{
            li{
                width: 337px;
                display: flex;
                justify-content:flex-start;
                align-items: center;
                flex-direction: column;
                .ul-li-img{
                    width: 337px;
                    height: 170px;
                    background: url("../../../assets/images/newImg/supplier6.png");
                }
                .ul-li-titlt1{
                    font-size: 16px;
                    font-weight: 400;
                    color: #37312D;
                }
                .ul-li-titlt2{
                    font-size: 14px;
                    font-family: PingFang SC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #888888;
                    text-align: center;
                }
            }
        }
    }
    }
     .supplierAdminItem6bg{
        background: url('../../../assets/myimage/pingtai2.webp');
        background-size: 100% 100%;
        padding-bottom: 30px !important;
        padding-top: 30px !important;
        .supplierAdminItem6{
             .supplierAdminItem6Title{
               display: flex;
               justify-content: center;
               font-size: 28px !important;
               color: #fff;
               
             }
             .supplierAdminItem6-item{
                display: flex;
                justify-content: center;
                align-items: center;
                padding: 0 50px;
                .supplierAdminItem6-item-title{
                    width: 60px;
                    height: 60px;
                    line-height: 60px;
                    text-align: center;
                    background: #FD681C;
                    border-radius: 6px 6px 6px 6px;
                    opacity: 1;
                    font-size: 40px;
                    font-family: PingFang SC-Semibold, PingFang SC;
                    font-weight: 600;
                    color: #FFFFFF;
                }
                .supplierAdminItem6-item-title2{
                    font-size: 14px;
                    font-family: PingFang SC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #FFFFFF;
                    text-align: left;
                    margin-left: 40px;
                    >h1:first-child{
                        font-style:italic;
                        margin-bottom:5px ;
                    }
                }
             }
        }
    }
    
    .ERPShopAdminItem8{
        .ERPShopAdminItem8Title{
            font-size: 36px;
            font-family: PingFang SC-Semibold, PingFang SC;
            font-weight: 400;
            color: #000000;
            text-align: center;
        }
        .ERPShopAdminItem8_ul1{
            li{
               flex: 1;
               display: flex;
               justify-content: center;
               align-items: center;
               flex-direction: column;
               margin-right: 70px;
               &:last-child{
                 margin-right: 0px;
               }
               .ul-li-img{
                  width: 120px;
                  height: 108px;
                  background: url("../../../assets/images/newImg/indexImg1.png");
                 
               }
               .ul-li-title1{
                  font-size: 16px;
                  font-weight: 400;
                  color: #000000;
               }
               .ul-li-title2{
                  font-size: 14px;
                  font-weight: 400;
                  color: #999999;
                  height: 55px;
               }
               .ul-li-title3{
                 font-size: 16px;
                 font-weight: 400;
                 color: #FD681C;
                 cursor: pointer;
               }
            }
        }
        .ERPShopAdminItem8_ul2{
             li{
                width: 210px;
                background: url("../../../assets/images/newImg/indexImg9.png");
                background-size: 100% 100%;
                background-repeat: no-repeat;
                justify-content: center;
                align-items:flex-start;
                flex-direction: column;
                padding: 30px 60px 60px;
                & img{
                    height: 30px ;
                }
                .ul-li-title1{
                    font-size: 22px;
                    font-weight: 400;
                    color: #000000;
                }
                .ul-li-title2{
                    height: 55px;
                    font-size: 14px;
                    font-weight: 400;
                    color: #555555;
                }
                 .ul-li-title3{
                    font-size: 14px;
                    font-weight: 400;
                    display: flex;
                    .btn{
                        width: 102px;
                        height: 30px;
                        line-height: 30px;
                        text-align: center;
                        border-radius: 2px 2px 2px 2px;
                        opacity: 1;
                        cursor: pointer;
                    }
                    .btn-1{
                         color:#FD681C;
                         border: 1px solid #FD681C;
                    }
                    .btn-2{
                        margin-left: 12px;
                        color: #C9CDD4;
                         border: 1px solid #C9CDD4;
                    }
                }
             }
        }
        .goMoreterrace{
            width: 192px;
            height: 38px;
            line-height: 38px;
            text-align: center;
            margin: 30px auto 20px;
            border-radius: 0px 0px 0px 0px;
            opacity: 1;
            border: 1px solid #FD681C;
            font-size: 14px;
            font-weight: 400;
            color: #FD681C;
            cursor: pointer;
        }
    }
    
 }
</style>
<style lang="scss" scoped>
@media  screen and (max-width:760px) {

 .new_ERPShopAdmin{
    font-family: PingFang SC-Regular, PingFang SC;
     .ERPShopAdminbanner{
         background-size:130% 100%;
         height: 350px;
         position: relative;
         .ERPShop-bannnertext{
            width: 78%;
            top:70px !important;
            left:10px !important;
            .ERPShop-bannnertext1{
                font-size: 22px !important;
                font-weight: bold;
              
            }
            .ERPShop-bannnertext2{
               margin-top: 10px;
               font-size: 14px;
               padding-right: 10px;
            }
            .ERPShop-bannnertext3{
               margin-top: 10px !important;
               font-size: 14px;
               padding-right: 77px;
               color: #ffffffab;
                
            }
            
            .ERPShop-bannnerbtn{
                margin-top: 20px !important;
                
            }
         }
    }

   .ERPShopAdminItem5bg{
        background: #FFF;
        padding-top:10px !important;
        .ERPShopAdminItem5{
        .ERPShopAdminItem5-top{
            background-size: 100% 100%;
            padding-bottom: 20px !important;
            .ERPShopAdminItem5-top-View{
                position: relative;
                font-size: 28px;
                font-family: PingFang SC-Medium, PingFang SC;
                font-weight: 400;
                color: #4E5968;
                & span{
                    margin-left: 0 !important;
                    position: relative;
                    bottom: 13px;
                    z-index: 10;
                }
            }
            .ERPShopAdminItem5-top-View2{
                font-size: 14px;
                padding:0 10px !important;
                text-align: center;
            }
        } 
        .ERPShopAdminItem5-ul1{
            flex-direction: column;
            & li{
                flex: 1;
                padding: 0px !important;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
                margin-bottom: 20px ;
                .ul-title1{
                    font-size: 16px;
                    font-family: PingFang SC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #000;
                    margin: 10px 0 10px 0;
                }
                .ul-title2{
                    padding: 0 30px !important;
                }
                .ul-title-btn{
                    margin-top: 6px;
                    font-size: 14px;
                    font-family: PingFang SC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #FD681C;
                    text-align: center;
                    cursor: pointer;
                }
            }
        }
        .ERPShopAdminItem5-ul{
            background: #FFF;
             flex-direction: column;
             padding: 0 10px !important;
            & li{
                width:100%;
                height: auto !important;
                padding:15px 0 15px 10px !important;
                .ul-img{
                    & img{
                        width: 120px;
                    }
                    // width: 40px;
                    // height: 38px;
                    // background: url("../../../assets/images/newImg/ERPShopImg4.png");
                }
                .ul-title1{
                    font-size: 16px;
                    font-family: PingFang SC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #000;
                }
                .ul-title2{
                    font-size: 14px;
                    font-family: PingFang SC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #9898A4;
                    height: auto !important;
                    padding-right: 30px;
                }
                .ul-title-btn{
                    margin-top: 6px;
                    font-size: 14px;
                    font-family: PingFang SC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #FD681C;
                    width: 100px;
                    height: 34px;
                    border-radius: 2px 2px 2px 2px;
                    border: 1px solid #FD681C;
                    line-height: 34px;
                    text-align: center;
                    cursor: pointer;
                }
            }
           
            
           
        }
       
        }
    }
     .ERPShopAdminItem6bg{
        background:#FFF;
        .ERPShopAdminItem6{
             .ERPShopAdminItem6Title{
                font-size: 20px;
                font-family: PingFang SC-Semibold, PingFang SC;
                font-weight: 600;
                color: #000000;
                text-align: center;
             }
             .ERPShopAdminItem6-item{
                li{
                    width: 297px;
                    height: 278px;
                    padding: 30px 20px 0 20px;
                    background: linear-gradient(312deg, #FAFEFF 0%, #F2F3F7 100%);
                    box-shadow: 0px 3px 21px 1px rgba(56,89,197,0.03);
                    border-radius: 8px 8px 8px 8px;
                    opacity: 1;
                    border: 2px solid #FFFFFF;
                    .ERPShopAdminItem6-text{
                        font-size: 18px;
                        font-family: PingFang SC-Medium, PingFang SC;
                        font-weight: 500;
                        color: #000000;
                    }
                    .ERPShopAdminItem6-text2{
                        font-size: 15px;
                        font-family: PingFang SC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #999999;
                        padding-right:60px;
                        margin-top: 20px;
                    }
                    .ERPShopAdminItem6-btn{
                        display: flex;
                        justify-content: space-between;
                        & div{
                            width: 100px;
                            height: 30px;
                            line-height: 30px;
                            text-align: center;
                            margin-top: 50px;
                            border-radius: 2px 2px 2px 2px;
                            opacity: 1;
                            border: 1px solid #FD681C;
                            font-size: 14px;
                            font-family: PingFang SC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #FD681C;
                            cursor: pointer;
                        }
                        & img{
                            width: 170px;
                        }
                    }
                }
                
             }
        }
    }
    .supplierAdminItem5bg{
        background: #FFF;
        padding-top:30px !important;
        padding-bottom: 10px !important;
        .supplierAdminItem5{
        .supplierAdminItem5Title{
           font-size: 28px;
        }
        .supplierAdminItem5Title2{
            font-size: 16px;
             text-align: center;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
        }
        
        .supplierAdminItem5-ul{
              flex-wrap: wrap;
            li{
               width: 45%;
                display: flex;
                justify-content:flex-start;
                align-items: center;
                flex-direction: column;
                .ul-li-img{
                    width: 100%;
                    height: 100px;
                    background: url("../../../assets/images/newImg/supplier6.png");
                }
                .ul-li-titlt1{
                    font-size: 16px;
                    font-weight: 400;
                    color: #37312D;
                }
                .ul-li-titlt2{
                    font-size: 14px;
                    font-family: PingFang SC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #888888;
                    text-align: center;
                }
            }
        }
    }
    }
     .supplierAdminItem6bg{
        background: url('../../../assets/images/newImg/supplier5.png');
        background-size: 230% 100%;
        .supplierAdminItem6{
             .supplierAdminItem6Title{
               font-size: 36px;
                font-family: PingFang SC-Semibold, PingFang SC;
                font-weight: 400;
                color: #FFF;
                text-align: center;
                text-decoration: solid 2px #FD681C;
             }
             .supplierAdminItem6View{
                flex-wrap: wrap;
                    .supplierAdminItem6-item{
                        width: 49% !important;
                        display: flex;
                        justify-content: center;
                        flex-direction: column;
                        align-items: center;
                        padding: 0 !important;
                        margin-bottom: 20px !important;
                        .supplierAdminItem6-item-title2{
                           
                            padding: 0 30px;
                        }
                    }
             }
           
        }
    }
    
    .ERPShopAdminItem8{
        .ERPShopAdminItem8Title{
            padding-top:10px !important;
            font-size: 28px !important;
            margin-bottom: 30px !important;
          
        }
        .ERPShopAdminItem8_ul1{
            flex-direction: column;
            li{
               margin-right: 0 !important;
               margin-bottom: 20px !important;
               &:last-child{
                 margin-right: 0px;
               }
               .ul-li-img{
                  width: 120px;
                  height: 108px;
                  background: url("../../../assets/images/newImg/indexImg1.png");
                 
               }
               
               .ul-li-title2{
                  height: auto !important;
                  padding:0 20px !important;
                  text-align: center;
               }
              
            }
        }
        .ERPShopAdminItem8_ul2{
             li{
                width: 210px;
                background: url("../../../assets/images/newImg/indexImg9.png");
                background-size: 100% 100%;
                background-repeat: no-repeat;
                justify-content: center;
                align-items:flex-start;
                flex-direction: column;
                padding: 30px 60px 60px;
                & img{
                    height: 30px ;
                }
                .ul-li-title1{
                    font-size: 22px;
                    font-weight: 400;
                    color: #000000;
                }
                .ul-li-title2{
                    height: 55px;
                    font-size: 14px;
                    font-weight: 400;
                    color: #555555;
                }
                 .ul-li-title3{
                    font-size: 14px;
                    font-weight: 400;
                    display: flex;
                    .btn{
                        width: 102px;
                        height: 30px;
                        line-height: 30px;
                        text-align: center;
                        border-radius: 2px 2px 2px 2px;
                        opacity: 1;
                        cursor: pointer;
                    }
                    .btn-1{
                         color:#FD681C;
                         border: 1px solid #FD681C;
                    }
                    .btn-2{
                        margin-left: 12px;
                        color: #C9CDD4;
                         border: 1px solid #C9CDD4;
                    }
                }
             }
        }
        .goMoreterrace{
            width: 192px;
            height: 38px;
            line-height: 38px;
            text-align: center;
            margin: 30px auto 20px;
            border-radius: 0px 0px 0px 0px;
            opacity: 1;
            border: 1px solid #FD681C;
            font-size: 14px;
            font-weight: 400;
            color: #FD681C;
            cursor: pointer;
        }
    }
    .u-m-t-20{
        margin-top: 0px !important;
    }
    .last4{
        // margin-left: -3px !important;
        white-space:nowrap
    }
    .last3{
        // margin-left: -17px !important;
        white-space:nowrap
    }
    .last2{
    //    margin-left: 17px !important; 
       white-space:nowrap;
    //    display: none;
    }
    
 }
}
</style>